import { render, staticRenderFns } from "./DocumentMenu.vue?vue&type=template&id=f0226248&scoped=true"
import script from "./DocumentMenu.vue?vue&type=script&lang=js"
export * from "./DocumentMenu.vue?vue&type=script&lang=js"
import style0 from "./DocumentMenu.vue?vue&type=style&index=0&id=f0226248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0226248",
  null
  
)

export default component.exports